import { render } from "./DataWalletCreate.vue?vue&type=template&id=76cf7c43&scoped=true"
import script from "./DataWalletCreate.vue?vue&type=script&lang=js"
export * from "./DataWalletCreate.vue?vue&type=script&lang=js"

import "./DataWalletCreate.vue?vue&type=style&index=0&id=76cf7c43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cf7c43"],['__file',"src/pages/DataWalletCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76cf7c43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76cf7c43', __exports__)) {
    api.reload('76cf7c43', __exports__)
  }
  
  module.hot.accept("./DataWalletCreate.vue?vue&type=template&id=76cf7c43&scoped=true", () => {
    api.rerender('76cf7c43', render)
  })

}


export default __exports__